import { motion } from "framer-motion";
import { fadeUp, SectionLabel } from "./shared";

export const Intro = () => (
    <section
        id="bemutatkozas"
        data-testid="intro-section"
        className="relative bg-white py-24 sm:py-32 lg:py-40 border-b border-black/10"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                    className="lg:col-span-4"
                >
                    <SectionLabel num="01" label="Bemutatkozás" />
                    <h2 className="mt-6 font-display font-extrabold text-3xl sm:text-4xl leading-tight">
                        <span className="text-[#0D7A73]">Stabilor</span>
                    </h2>
                </motion.div>

                <motion.div
                    variants={fadeUp}
                    custom={1}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                    className="lg:col-span-8 space-y-8"
                >
                  
                    <p className="text-slate-700 text-lg leading-relaxed max-w-3xl">
                        A <span className="text-[#0D7A73]">Stabilor</span> több mint 20 év tapasztalattal nyújt professzionális kivitelezési szolgáltatásokat lakossági és üzleti ügyfelek számára. Teljeskörű lakásfelújítás a tervezéstől egészen a kulcsrakész átadásig.
                        <br/><br/>
                        Célunk, hogy korszerű, hosszú távon megbízható és költséghatékony megoldásokat biztosítsunk ügyfeleink számára. Munkáink alapja minden esetben a részletes helyszíni felmérés, amely lehetővé teszi az ingatlan adottságaihoz és az egyedi igényekhez legjobban illeszkedő kivitelezési terv elkészítését.
                    </p>

                </motion.div>
            </div>
        </div>
    </section>
);
